
import {Vue, Component, Prop} from "vue-property-decorator";
import { mdiDomain, mdiDoorOpen, mdiStore } from "@mdi/js";
import SvgIcon from "@jamescoyle/vue-icon";

@Component({
  components: { SvgIcon },
})
export default class CustomChipLink extends Vue {
    @Prop({default: null})
    public type: string;

    @Prop({default: null})
    public id: number;

    @Prop({default: null})
    public text: string;

    get route(): any {
        if (!this.id) {
            return null;
        }
        switch (this.type) {
            case "user":
                return {
                    name: "user",
                    params: { id: this.id },
                };
            case "key":
                return {
                    name: "key",
                    params: { id: this.id },
                };
            case "otherKey":
                return {
                    name: "key",
                    params: { id: this.id },
                };
            case "relay":
                return {
                    name: "relay",
                    params: { id: this.id },
                };
            case "building":
                return {
                    name: "building",
                    params: { id: this.id },
                };
            case "nonTransferable":
                return {
                    name: "non-transferable",
                    params: { id: this.id },
                };
            case "userGroup":
                return {
                    name: "contacts",
                    params: {
                        tab: "groups",
                    },
                };
            case "keyGroup":
                return {
                    name: "keys",
                    params: {
                        tab: "groups",
                        groupId: this.id,
                    },
                };
            case "picture":
                return {
                    name: "picture",
                    params: { id: this.id },
                };
            default:
                return null;
        }
    }

    get color(): string {
        switch (this.type) {
            case "user":
                return "warning";
            case "key":
            case "otherKey":
                return "blue";
            case "category":
                return "indigo";
            case "relay":
            case "building":
                return "green";
            case "userGroup":
            case "keyGroup":
                return "red";
            case "picture":
                return "pink";
            case "nonTransferable":
                return "brown";
            default:
                return "";
        }
    }

    get vuetifyIcon(): string {
        switch (this.type) {
            case "user":
                return "person";
            case "userGroup":
                return "people";
            case "key":
            case "otherKey":
            case "keyGroup":
                return "vpn_key";
            default:
                return "";
        }
    }

    get mdiIcon(): string {
        switch (this.type) {
            case "relay":
                return mdiStore;
            case "building":
                return mdiDomain;
            case "nonTransferable":
                return mdiDoorOpen;
            default:
                return "";
        }
    }
}
